// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"a92b2077","223":"1346a5e7","239":"64e14742","504":"8ff3ee73","921":"cd9b8bcf","946":"a680470d"}[chunkId] + ".chunk.js";
};